import React, {Component} from 'react';
import {Row, Col} from 'react-grid-system'
import './Record.css';
import moment from "moment";
import _ from "underscore";
import Format from "./Format";
import YouTube from 'react-youtube';
import {Link} from 'react-router-dom'


class Record extends Component {

    findPos(obj) {
        let curtop = 0;
        if (obj.offsetParent) {
            do {
                curtop += obj.offsetTop;
            } while (obj = obj.offsetParent);
            return [curtop - 50];
        }
    }

    render() {
        window.scroll(0, this.findPos(document.getElementById("Incredible-Root")));


        const entry = this.props.entry.fields['Activité'][0];
        const photo = entry.fields["Photos promo"];
        let firstPhoto = true;
        let title = this.props.entry.fields['Activité'][0].fields['Titre: Nom de l\'intervention'];

        const dateStart = moment(this.props.entry.fields['Date et heure début']);
        const dateEnd = moment(this.props.entry.fields['Date et heure fin']);
        let date = null;
        if (dateStart.format('HH:mm') === dateEnd.format('HH:mm')) {
            date = dateStart.format('DD/MM - HH:mm');
        } else {
            date = dateStart.format('DD/MM - HH:mm') + ' - ' + dateEnd.format('HH:mm');
        }


        let places = [];
        _.each(this.props.entry.fields['Lieu'], (place) => {
            places.push(place.fields.Name);
        })

        let intervenants = null;
        let users = [];
        _.each(this.props.entry.fields['Intervenants'], (place) => {
            users.push(place.fields['Nom complet']);
        })

        if (users.length) {
            intervenants = (
                <div className="Record-Detail">
                    <i className="fas fa-users"/>
                    <span>Intervenants</span>
                    <b>{users.join(', ')}</b>
                </div>
            );
        }

        let themes = [];
        _.each(this.props.entry.fields['Thème'], (place) => {
            themes.push(place.fields['Thématique']);
        })

        let video = null;
        if (this.props.entry.fields['Bande annonce']) {
            firstPhoto = false;
            let videoId = this.YouTubeGetID(this.props.entry.fields['Bande annonce']);
            if (videoId !== this.props.entry.fields['Bande annonce']) {
                video = (
                    <Col sm={12}>
                        <YouTube
                            videoId={videoId}
                            opt={{
                                height: '390',
                                width : '100%',
                            }}
                            style={{margin: 'auto', width: '100%'}}
                        />
                    </Col>
                );
            }
        }

        let reservation = null;
        if (this.props.entry.fields['Inscription via Eventbrite']) {
            reservation = (
                <div style={{marginTop: '20px', textAlign: 'center'}}>
                    <a className="Record-Reservation" href={this.props.entry.fields['Inscription via Eventbrite']}
                       target="_blank">
                        Réservation obligatoire
                    </a>
                </div>
            );
        }


        let facilitateur = null;
        users = [];
        _.each(this.props.entry.fields['Facilitateur'], (u) => {
            if (u.fields['Nom complet'] != '' && u.fields['Nom complet'] != ' ') {
                users.push(u.fields['Nom complet']);
            }
        })

        if (users.length) {
            facilitateur = (
                <div className="Record-Detail">
                    <i className="fas fa-user"/>
                    <span>Facilitateur</span>
                    <b>{users.join(', ')}</b>
                </div>
            );
        }

        let displayBackButton = null;
        if (this.props.displayBackButton) {
            displayBackButton = (
                <div style={{textAlign: 'center'}}>
                    <Link to="/" className="Record-Reservation" style={{marginBottom: '20px'}}>
                        Revenir à la liste des activités
                    </Link>
                </div>
            );
        }


        return (
            <div className="Record">
                {displayBackButton}
                <Row>
                    <Col md={6} style={{textAlign: 'center'}}>
                        <Row>
                            {video}
                            {!photo ? null : photo.map((photo) => {
                                if (firstPhoto) {
                                    firstPhoto = false;
                                    return <Col sm={12}><a href={photo.thumbnails.large.url} target="_blank"><img
                                        src={photo.thumbnails.large.url} className="Record-Photo-Main"/></a></Col>;
                                } else {
                                    if (photo.thumbnails) {
                                        return (
                                            <Col sm={4}>
                                                <a href={photo.thumbnails.large.url} target="_blank">
                                                    <img src={photo.thumbnails.large.url} style={{maxWidth: '100%'}}/>
                                                </a>
                                            </Col>
                                        );
                                    } else {
                                        return (
                                            <Col sm={4}>
                                                <a href={photo.url} target="_blank">
                                                    <img src={photo.url} style={{maxWidth: '100%'}}/>
                                                </a>
                                            </Col>
                                        );
                                    }
                                }
                            })}
                        </Row>
                    </Col>
                    <Col md={6}>
                        <h1>{title}</h1>

                        <Row>
                            <Col md={6}>
                                <div className="Record-Detail">
                                    <i className="far fa-clock"/>
                                    <span>Heure</span>
                                    <b>{date}</b>
                                </div>
                                <div className="Record-Detail">
                                    <i className="fas fa-map-marker-alt"/>
                                    <span>Lieu</span>
                                    <b>{places.join(', ')}</b>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="Record-Detail">
                                    <i className="fas fa-street-view"/>
                                    <Format entry={this.props.entry}/>
                                </div>
                                <div className="Record-Detail">
                                    <i className="far fa-hand-point-right"/>
                                    <span>Parcours</span>
                                    <b>{themes.join(', ')}</b>
                                </div>
                            </Col>
                        </Row>

                        {facilitateur}
                        {intervenants}

                        <div className="Record-Info"
                             dangerouslySetInnerHTML={{__html: entry.fields.Description ? this.nl2br(entry.fields.Description, true) : null}}/>

                        {reservation}
                    </Col>
                </Row>
            </div>
        );
    }

    YouTubeGetID(url) {
        var ID = '';
        url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if (url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        } else {
            ID = url;
        }
        return ID;
    }

    nl2br(str, is_xhtml) {
        let breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display

        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

}


export default Record;


// WEBPACK FOOTER //
// ./src/Components/MaintenantCardsV2/Record.js